const now = +(new Date());
let index = 0;

export default function uid() {
  return `rc-upload-${now}-${++index}`;
}



// WEBPACK FOOTER //
// ./_rc-upload-2.2.0/src/uid.js